import React from "react";
import Card from "../../../../core/Card";
import Typography from "../../../../core/Typography";
import Button from "../../../../core/Button";
import Checkbox from "../../../../core/CheckBox";
import Input from "../../../../core/Inputs/DefaultInput";
import { useDevice } from "../../../customHooks";
import { useEffect, useRef, useState } from "react";
import style from "../../../style.module.css";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Title from "../Title";
import Axios from "axios";
// routes
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resendOtp, verifyOtp, signUpverifyOtp } from "../../../../store/actions/authAction";
// import Header from "../../survey/survey-form/landing-page/widgets/Header";

export const EmailVerification = () => {

  let device = useDevice();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setOpen] = useState(false);
  const inputRef = useRef();
  const [count, setCount] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const [otpError, setotpError] = useState(false)
  const [checkotp, setcheckotp] = useState('');

  const [timer, setTimer] = useState(600); 

  useEffect(() => {
    const str = String(inputRef?.current?.props.value)?.length;
    setCount(str);
  }, []);
  const handleCount = e => {
    setCount(String(e.target.value).length);
  };

  const [otp, setOtp] = useState('');
  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get('email');

  const [timerStarted, setTimerStarted] = useState(false);

  useEffect(() => {
    if (!timerStarted) {
      const interval = setInterval(() => {
        setTimer(prevTimer => (prevTimer === 0 ? 600 : prevTimer - 1)); // Decrement timer every second
      }, 1000);
      // setTimerStarted(true);
      // Clear interval on component unmount or route change
      return () => clearInterval(interval);
    }
  }, [timerStarted, location]);

  useEffect(() => {
    if (timer === 0){
    setTimerStarted(true);
    }
  },[timer] )


  React.useEffect(() => {
    if (email == null) {
      window.location = '/';
    }
  });

  const successCallack = () => {
    navigate('/admin/roi')
  } 

  const formatTimer = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${formattedMinutes}:${formattedSeconds}`;
  };

  const checkOtp =() => {
   
    if (otp.trim() === '') {
        // OTP field is empty, set error state and display error message
        setotpError(true);
        setcheckotp('Please enter the OTP');
        return; // Exit function
    }
    let token = localStorage.getItem("token_id")
    let payload = {
      email: email,
      otp: otp,
      token: token
    }
    dispatch(signUpverifyOtp(payload, successCallack))
    //console.log(dispatch(verifyOtp(payload, successCallack)));
  }

  const otpResend = () => {
    setTimerStarted(false);
    let payload = {
      email: email,
    }
    //console.log(payload, "payload");
    // dispatch(resendOtp(payload))
    // console.log(dispatch(resendOtp(payload)))
    // console.log(process.env.REACT_APP_NODE_API_URL)
    Axios.post(process.env.REACT_APP_NODE_API_URL+"/users/resend-otp", {
      email: email
    })
      .then((response) => {
        // Check the response status and handle accordingly
        if (response.status === 200) {
            toast.success(response.data.msg);
        } else {
          //alert("Unable to sign up");
          toast.error("Unable to send. Please try again later.");
        }
      })
      .catch((error) => {
        console.error("Error signing up:", error);
        // alert("Unable to sign up. Please try again later.");
        toast.error("Unable to send. Please try again later.");
      });


  }

  return (
    <>
      <div className='d-flex flex-column site-main-wrapper login-page'>
        {/* <Header /> */}
        <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
          <div className="container">
            <div className="form-wrapper">
              <div className="form-heading text-center">
                <h3>Verify email</h3>
                <p>We've sent a verification 6-digit OTP code to your email address: <span className="black">{email} </span>, please enter it below to verify email</p>
              </div>
              <div className="field-wrapper">
               {
                (otpError) ?
                  <>
                    <div className={(!otpError) ? "success" : "validation-msg"} style={{top: '57%'}}>
                      {(!otpError) ? '' : checkotp}
                    </div>
                  </>
                  : ''
                }

                < Input
                  ref={inputRef}
                  type='text'
                  view='outlined'
                  dense={false}
                  color='default'
                  label=''
                  placeholder='Enter OTP'
                  clearButton={true}
                  success={false}
                  error={false}
                  fill={true}
                  errorHelperText={null}
                  className={"formsinput"}
                  value={otp}
                  name="otp"
                  onInput={(e) => {
                    setOtp(e.target.value);
                    setotpError(false);
                  }}
                  required
                  //inputMode="numeric" // Only allow numeric input
                  maxLength={6} 
                  // onKeyPress={(e) => {
                  //     // Prevent non-numeric characters
                  //     const pattern = /^[0-9\b]+$/;
                  //     if (!pattern.test(e.key)) {
                  //         e.preventDefault();
                  //     }
                  // }}            
                />
                <div className="additional-info d-flex justify-content-between mb__20 pt-1">
                  <div className="text-primary">
                    <Typography
                      type="caption"
                      fill={true}
                      color="primary"
                      colorStep={60}
                      tagName="div"
                    >
                    <b className={timerStarted ? "d-none" : "d-block"}>  {formatTimer(timer)}</b>
                    </Typography>
                 
                  </div>
                  <a disabled={!timerStarted}>
                    <Typography
                      type="caption"
                      fill={true}
                      colorStep={60}
                      tagName="div"
                    >
                     <b onClick={otpResend} className={timerStarted ? "text-primary" : "text-secondary"} > Resend code</b>
                    </Typography>
                   </a>
                </div>
                
                
              </div>
              <div className="button-wrap">
                {/* <Link to="/AccountSetUp">*/}
                <Button className={"formsbutton btn btn-primary"}
                  type="default"
                  view="filled"
                  color="primary"
                  text="Submit"
                  fill={true}

                  // onClick={() => setOpen(true)}
                  onClick={checkOtp}
                />
                {/* </Link> */}
              </div>
              <div className="form-text text-center">
                <p>Wrong email address? <Link to="/"> Change it</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailVerification;
